import API from "@aws-amplify/api";
import { PREFIX } from "./config";
import { version } from "../../../package";
import axios from 'axios';

// NOTE: for local development, set to 'true' and bring up wg-api-server-java
// TODO: bette mechanism to detect local development, so we don't accidentally commit this flag
const devServer = false;

export default (name, body = {}, method = "post") => {
	!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

	body.clientType = "WEB_VIEW";
	body.clientView = "ADVICE";
	body.clientVersion = version;
	body.forClientType =
		navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
			? "IOS_APP"
			: "ANDROID_APP";

    if (!devServer) {
        // Call AWS Lambda
	    const path = PREFIX + name + "/invocations";
    	return API[method]("lambda", path, { body });
    } else {
        // Call local dev REST API
	const path = "http://localhost:8080/dev/" + name;
	return axios.post(path, body).then((postResult) => {
	                                    // Extract .data field from Axios response, that's the response body
                                        return postResult.data;
                                      });

    }
};
